import { render } from "./Lifetime.vue?vue&type=template&id=74b250a2&scoped=true"
import script from "./Lifetime.vue?vue&type=script&lang=js"
export * from "./Lifetime.vue?vue&type=script&lang=js"

import "./Lifetime.vue?vue&type=style&index=0&id=74b250a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\giragwe\\Documents\\Github\\2022-PO-JER-GoogleMars\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b250a2"]])

export default __exports__